// Detecção de ambiente Android e pontes nativas expostas pelo WebView.
//
// O wrapper Kotlin (CapoeiraSoul Android) injeta interfaces no window:
// - window.AndroidBridge   — geral (login Google, orientação)
// - window.AndroidBilling  — compras Google Play (premium)
//
// Em web puro, essas interfaces não existem; os helpers retornam null
// pra que o React possa decidir entre fluxo nativo vs web fallback.

const ANDROID_APP_UA_TOKEN = 'CapoeiraSoulAndroid/'

export function isAndroidApp(): boolean {
  if (typeof navigator === 'undefined') return false
  return navigator.userAgent.includes(ANDROID_APP_UA_TOKEN)
}

interface AndroidBridge {
  isAvailable?: () => boolean
  loginWithGoogle?: () => void
  lockPortrait?: () => void
  lockLandscape?: () => void
  getAppVersion?: () => string
}

interface AndroidBilling {
  buyPremium?: () => void
  acknowledgePremium?: (token: string) => void
  isBillingReady?: () => boolean
  showBanner?: () => void
  hideBanner?: () => void
}

export function androidBridge(): AndroidBridge | null {
  if (typeof window === 'undefined') return null
  const b = (window as any).AndroidBridge
  return b && typeof b.isAvailable === 'function' && b.isAvailable() ? b : null
}

export function androidBilling(): AndroidBilling | null {
  if (typeof window === 'undefined') return null
  const b = (window as any).AndroidBilling
  if (!b || typeof b.buyPremium !== 'function') return null
  return b
}

export function canPurchaseInApp(): boolean {
  return isAndroidApp() && androidBilling() !== null
}
